import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Section } from "./Section";
import { FAQ as FAQ_COPY } from "@/content/landing";

export function FAQ() {
  return (
    <Section
      id="faq"
      testId="landing-faq"
      eyebrow={FAQ_COPY.eyebrow}
      title={FAQ_COPY.title}
    >
      <div className="mx-auto max-w-3xl">
        <Accordion
          type="single"
          collapsible
          className="w-full"
          data-testid="landing-faq-accordion"
        >
          {FAQ_COPY.items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`landing-faq-item-${i}`}
              className="border-border/60"
            >
              <AccordionTrigger className="py-5 text-left text-base font-medium text-foreground hover:no-underline sm:text-lg">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-sm leading-relaxed text-muted-foreground sm:text-[15px]">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </Section>
  );
}
